module.exports = __webpack_public_path__ + "static/media/d4ffabb3-dd7c-472a-bdfb-6700383c6354-greek.f4f4ea95.woff";